import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { WorkItemSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, WorkItemsFilterSchema } from "../ea.schema.query";

const base = "work-items";
const wi = createEndpointBase(base);

export const workItemsEndpoints = {
  workItemsGet: wi({
    method: "GET",
    path: "",
    request: z.object({ filter: WorkItemsFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(WorkItemSchemas["general"]),
    description: "Retrieves a list of work items with filtering support.",
  }),
  workItemsCount: wi({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of work items matching the filters.",
  }),
  workItemsCreate: wi({
    method: "POST",
    path: "",
    request: WorkItemSchemas["createData"],
    response: WorkItemSchemas["general"],
    description: "Creates a new work item.",
  }),
} as const;
